<template>
  <b-overlay
    :show="busy"
    spinner-type="grow"
    spinner-variant="primary"
    rounded="sm"
  >
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0 px-0">
          <b-tabs class="gridtabs">
            <b-tab active>
              <template #title>
                <!-- <i :class="options.icon_header" class="text-primary mr-1"></i> -->
                <i :class="sheeticon" class="mr-1 text-primary"></i>
                <span class="text-warning">&lt; edit &gt;</span>
              </template>
              <e-table
                v-if="!component"
                class="etable"
                :refid="'etable'"
                :icon="sheeticon + ' text-primary'"
                :busy="carbonemissions.busy"
                :tools="carbonemissions.tools"
                :fields="carbonemissions.fields"
                :items="carbonemissions.items"
                :showfab="false"
                :showsheets="true"
                :showpages="false"
                :showrowcount="false"
                :showautoadd="false"
                @click="carbonemissions_click"
                @select="carbonemissions_select"
              />
              <!-- @toolClick="carbonemissions_toolClick"
                @change="carbonemissions_update"
                @select="carbonemissions_select" -->
              <div v-if="component">
                <component
                  :is="component"
                  :selection="carbonemissions.selected"
                  :config="cconfig"
                  @saveit="saveit"
                  @discard="toolClick('discard')"
                  @refresh="toolClick('refresh')"
                ></component>
              </div>
            </b-tab>

            <!-- <b-tab>
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row v-if="idselected">
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Created At"
                      label-for="created_at"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker
                            size="sm"
                            v-model="item.created_at"
                            button-only
                            label-help=""
                            locale="en-GB"
                            :disabled="true"
                          ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                          size="sm"
                          id="date"
                          v-model="item.created_at"
                          type="text"
                          placeholder="YYYY-MM-DD"
                          autocomplete="off"
                          :disabled="true"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.created_at = null"
                            :disabled="true"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Created By"
                      label-for="created_by"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.created_by"
                          placeholder=""
                          size="sm"
                          :disabled="true"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.created_by = ''"
                            :disabled="true"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Updated At"
                      label-for="updated_at"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker
                            size="sm"
                            v-model="item.updated_at"
                            button-only
                            label-help=""
                            locale="en-GB"
                            :disabled="true"
                          ></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input
                          size="sm"
                          id="date"
                          v-model="item.updated_at"
                          type="text"
                          placeholder="YYYY-MM-DD"
                          autocomplete="off"
                          :disabled="true"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.updated_at = null"
                            :disabled="true"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Updated By"
                      label-for="updated_by"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.updated_by"
                          placeholder=""
                          size="sm"
                          :disabled="true"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.updated_by = ''"
                            :disabled="true"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab> -->
          </b-tabs>
        </b-card-body>

        <b-card-footer class="mt-2 ml-1">
          <b-row>
            <b-col class="text-left">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="3">
              <b-button
                size="sm"
                variant="secondary"
                class="mr-1"
                @click="discard"
              >
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>

              <b-button
                squared
                size="sm"
                variant="primary"
                @click="saveit()"
                v-if="user.permissions.includes('carbonemissions.save')"
              >
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "CarbonEmissionsEdit",
  components: {},
  props: ["variables"],
  async mounted() {
    await this.load();
  },
  computed: {
    sheeticon() {
      let icons = [
        "fa fa-plane",
        "fa fa-bed",
        "fa fa-car",
        "fa fa-train",
        "fa fa-taxi",
        "fa fa-bus",
        "fa fa-ship",
      ];
      if (this.variables.type < icons.length) {
        return icons[this.variables.type];
      } else {
        return "fa fa-globe";
      }
    },
  },
  data() {
    return {
      busy: false,
      readonly: false,
      items: [],
      options: {
        title: "Client Emissions Edit",
        icon_header: "fa fa-globe",
        icon: "fa fa-globe",
        debounce: 500,
      },
      component: null,
      carbonemissions: {
        busy: false,
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-primary",
            squared: "squared",
            icon: "fa fa-bed",
            position: "sheets",
            action: "type_1",
            label: "Accommodation",
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-primary",
            squared: "squared",
            icon: "fa fa-car",
            position: "sheets",
            action: "type_2",
            label: "Car",
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-primary",
            squared: "squared",
            icon: "fa fa-train",
            position: "sheets",
            action: "type_3",
            label: "Rail",
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-primary",
            squared: "squared",
            icon: "fa fa-taxi",
            position: "sheets",
            action: "type_4",
            label: "Taxi",
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-primary",
            squared: "squared",
            icon: "fa fa-bus",
            position: "sheets",
            action: "type_5",
            label: "Coach",
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-primary",
            squared: "squared",
            icon: "fa fa-ship",
            position: "sheets",
            action: "type_6",
            label: "Ferry",
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-primary",
            squared: "squared",
            icon: "fa fa-plane",
            position: "sheets",
            action: "type_0",
            label: "Flight",
          },
        ],
        tools: "back,save,refresh,add,cut,clipboard,pastespecial,export,sheet_1",
        fields: [],
        fields_1: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-100px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "quantity",
            label: "Qty",
            type: "text",
            placeholder: "Quantity",
            class: "text-right w-40px",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-60px",
            clearable: "true",
          },
          {
            key: "category",
            label: "R.Type",
            class: "text-left",
            type: "text",
            placeholder: "Type",
            class: "text-right w-50px",
            clearable: "true",
            datalist: ["SINGLE", "DOUBLE", "TWIN"],
          },
          {
            key: "supplier",
            label: "Hotel",
            class: "text-left",
            type: "text",
            placeholder: "Hotel",
            class: "text-right w-100px",
            clearable: "true",
          },

          {
            key: "quantity",
            label: "Rooms",
            type: "text",
            placeholder: "Rooms",
            class: "text-right w-40px",
            clearable: "true",
          },
          {
            key: "duration",
            label: "Nights",
            sortable: true,
            type: "text",
            placeholder: "Nights",
            class: "text-right w-40px",
            clearable: "true",
          },
        ],
        fields_2: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right ",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-170px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-25pct",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "category",
            label: "Car Type",
            type: "text",
            placeholder: "Car Type",
            class: "text-right w-140px",
            clearable: "true",
            datalist: [
              "MINI",
              "SUPERMINI",
              "LOWER_MEDIUM",
              "UPPER_MEDIUM",
              "EXECUTIVE",
              "LUXURY",
              "SPORTS",
              "DUAL_PURPOSE_4X4",
              "MPV",
              "SMALL_CAR",
              "MEDIUM_CAR",
              "LARGE_CAR",
              "AVERAGE_CAR",
              "SMALL_MOTORBIKE",
              "MEDIUM_MOTORBIKE",
              "LARGE_MOTORBIKE",
              "AVERAGE_MOTORBIKE",
            ],
          },
          {
            key: "supplier",
            label: "Supplier",
            class: "text-left",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "distance",
            label: "Distance KM",
            type: "text",
            placeholder: "Quantity",
            class: "text-right w-100px",
            clearable: "true",
          },
        ],
        fields_3: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-90px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-100px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-15pct",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-50px",
            clearable: "true",
          },

          {
            key: "endcity",
            label: "End City",
            type: "text",
            placeholder: "City",
            class: "text-right w-50px",
            clearable: "true",
          },
          {
            key: "category",
            label: "Rail Type",
            type: "text",
            placeholder: "Rail Type",
            class: "text-right w-60px",
            clearable: "true",
            datalist: [
              "NATIONAL_RAIL",
              "INTERNATIONAL_RAIL",
              "LIGHT_RAIL",
              "TRAM",
              "SUBWAY",
              "LONDON_UNDERGROUND",
            ],
          },
          {
            key: "supplier",
            label: "Supplier",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-80px",
            clearable: "true",
          },

          {
            key: "distance",
            label: "Journey KM",
            type: "text",
            placeholder: "Journey KM",
            class: "text-right w-50px",
            clearable: "true",
          },
        ],
        fields_4: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-100px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-80px",
            clearable: "true",
          },

          {
            key: "category",
            label: "Car Type",
            type: "text",
            placeholder: "Car Type",
            class: "text-right w-80px",
            clearable: "true",
            datalist: [
              "MINI",
              "SUPERMINI",
              "LOWER_MEDIUM",
              "UPPER_MEDIUM",
              "EXECUTIVE",
              "LUXURY",
              "SPORTS",
              "DUAL_PURPOSE_4X4",
              "MPV",
              "SMALL_CAR",
              "MEDIUM_CAR",
              "LARGE_CAR",
              "AVERAGE_CAR",
              "SMALL_MOTORBIKE",
              "MEDIUM_MOTORBIKE",
              "LARGE_MOTORBIKE",
              "AVERAGE_MOTORBIKE",
            ],
          },
          {
            key: "supplier",
            label: "Supplier",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "distance",
            label: "Distance KM",
            type: "text",
            placeholder: "Distance",
            class: "text-right w-70px",
            clearable: "true",
          },
        ],
        fields_5: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-80px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-60px",
            clearable: "true",
          },

          {
            key: "category",
            label: "Coach Type",
            type: "text",
            placeholder: "Coach Type",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "supplier",
            label: "Supplier",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "distance",
            label: "Distance KM",
            type: "text",
            placeholder: "Distance",
            class: "text-right w-80px",
            clearable: "true",
          },
        ],
        fields_6: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },

          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-100px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-20pct",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-60px",
            clearable: "true",
          },

          {
            key: "category",
            label: "Ferry Type",
            type: "text",
            placeholder: "Category",
            class: "text-right w-80px",
            clearable: "true",
            datalist: ["car", "coach", "foot", "average"],
          },
          {
            key: "supplier",
            label: "Supplier",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "distance",
            label: "Distance KM",
            type: "text",
            placeholder: "Distance",
            class: "text-right w-80px",
            clearable: "true",
          },
        ],
        fields_0: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-120px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "Start City",
            class: "text-right w-80px",
            clearable: "true",
          },

          {
            key: "endcity",
            label: "End City",
            type: "treeselect",
            placeholder: "End City",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "category",
            label: "Class",
            type: "text",
            placeholder: "Class",
            class: "text-right w-90px",
            clearable: "true",
            datalist: ["ECONOMY", "PREMIUM", "BUSINESS", "FIRST"],
          },
          {
            key: "flightno",
            label: "FlightNo",
            type: "text",
            placeholder: "FlightNo",
            class: "text-right w-90px",
            clearable: "true",
          },
          {
            key: "confirmationno",
            label: "Locator",
            type: "text",
            placeholder: "Locator",
            class: "text-right w-90px",
            clearable: "true",
          },
          {
            key: "vehicle",
            label: "Aircraft",
            type: "text",
            placeholder: "Aircraft",
            class: "text-right w-90px",
            clearable: "true",
          },
          {
            key: "ticketno",
            label: "TicketNo",
            type: "text",
            placeholder: "TicketNo",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "supplier",
            label: "Supplier",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-70px",
            clearable: "true",
          },
        ],
        items: [],
        selected: [],
      },
    };
  },
  methods: {
    async load(o, l) {
      console.log("load", o, l);

      this.carbonemissions.busy = true;
      this.carbonemissions.items = [];

      let variables = { ...this.variables };
      console.log("carbonemissions variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query carbonemissions(
              $limit: Int
              $offset: Int
              $type: String
              $eventcode: String
              $slac: String
              $travel_at: [String]
              $traveller: String
              $startcity: String
              $duration: String
              $quantity: String
              $distance: String
              $category: String
              $flightno: String
              $ticketno: String
              $confirmationno: String
              $vehicle: String
              $supplier: String
              $endcity: String
              $anonymiser: Boolean
              $dateformat: String
            ) {
              carbonemissions(
                limit: $limit
                offset: $offset
                type: $type
                eventcode: $eventcode
                slac: $slac
                travel_at: $travel_at
                traveller: $traveller
                startcity: $startcity
                duration: $duration
                quantity: $quantity
                distance: $distance
                category: $category
                flightno: $flightno
                confirmationno: $confirmationno
                vehicle: $vehicle
                ticketno: $ticketno
                supplier: $supplier
                endcity: $endcity
                anonymiser: $anonymiser
                dateformat: $dateformat
              ) {
                id
                type
                eventcode
                slac
                traveller
                startdate
                startcity
                duration
                quantity
                distance
                category
                flightno
                confirmationno
                vehicle
                ticketno
                supplier
                enddate
                endcity
                rows
              }
            }
          `,
          variables,
        });

        this.items = response.data.carbonemissions;
        console.log("items=", this.items);

        this.carbonemissions.fields =
          this.carbonemissions["fields_" + variables.type];
        this.carbonemissions.items = response.data.carbonemissions;
      } catch (error) {
        console.log(error);
      }
      this.carbonemissions.busy = false;
    },
    async saveit() {
      //   this.message = this.$helpers.mandatoryFields(
      //     {
      //       type: "Type",
      //       eventcode: "Event",
      //       slac: "Client SL A/C",
      //       traveller: "Traveller",
      //       startdate: "Start Date",
      //       startcity: "City",
      //     },
      //     row
      //   );
      //   if (this.message.length > 0) {
      //     return;
      //   }

      this.busy = true;

      //   this.item.slac =
      //     this.item.slac.length > 0 ? this.item.slac.join(",") : null;
      //   this.item.eventcode =
      //     this.item.eventcode.length > 0 ? this.item.eventcode.join(",") : null;

      let variables = { rows: this.cleanit(this.carbonemissions.items) };
      for (var j = 0; j < variables.rows.length; j++) {
        //   variables.rows[j].slac.length > 0 ? variables.rows[j].slac.join(",") : null;
        //   variables.rows[j].eventcode.length > 0 ? variables.rows[j].eventcode.join(",") : null;
        delete variables.rows[j].startdate;
      }
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation carbonemissions_save(
              $rows: [Carbonemission_input]
              $dateformat: String
            ) {
              carbonemissions_save(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;

      this.load();
      return;
    },
    async carbonemissions_click(a, ss) {
      console.log("carbonemissions_click", a, ss);
      switch (a) {
        case "back":
          this.discard();
          break;
        case "refresh":
          this.load();
          break;
        case "save":
          await this.saveit();
          break;
        case "paste":
          this.carbonemissions_paste();
          // // this.$bvModal.show("carbonemissions-paste");
          break;
        case "add":
          this.carbonemissions_add();
          break;
        case "deleteit":
          this.carbonemissions_delete(ss);
          break;
      }
    },
    carbonemissions_select(ss, tools) {
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "refresh", "add", "pastespecial"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        tool = tools.find((o) => o.action == "sheet_1");
        if (tool) {
          tool.label = "Accommodation";
          tool.icon = this.sheeticon;
          tool.disabled = false;
        }
      }

      console.log("carbonemissions_select", ss, tools);
      this.carbonemissions.selected = ss;
    },
    carbonemissions_paste() {
      var clipboardData = window.clipboardData;
      // ||
      // event.clipboardData ||
      // (event.originalEvent && event.originalEvent.clipboardData);

      var pastedText =
        clipboardData.getData("Text") || clipboardData.getData("text/plain");

      if (!pastedText && pastedText.length) {
        return;
      }

      // Parse the pasted text from Excel into rows.
      // Pasted text is usually separated by a new line for each row,
      // but a single cell can contain multiple lines, which is what
      // we pars out in the first `replace`.
      //
      // We find all text within double-quotes ('"') which has new
      // lines, and put the text within the quotes into capture
      // groups. For each match, we replace its contents again, by
      // removing the new lines with spaces.
      //
      // Then lastly, once we've joined all the multi line cells, we
      // split the entire pasted content on new lines, which gives
      // us an array of each row.
      //
      // Since Windows usually uses weird line-endings, we need to
      // ensure we check for each of the different possible
      // line-endings in every regexp.
      //
      // It also handles cells which contains quotes. There appears
      // to be two ways this is handled. In Google Docs, quotes within
      // cells are always doubled up when pasting, so " becomes "".
      // In Libre Office, the quotes are not normal quotes, some
      // other character is used, so we don't need to handle it any
      // differently.
      var rows = pastedText
        .replace(
          /"((?:[^"]*(?:\r\n|\n\r|\n|\r))+[^"]+)"/gm,
          function (match, p1) {
            // This function runs for each cell with multi lined text.
            return (
              p1
                // Replace any double double-quotes with a single
                // double-quote
                .replace(/""/g, '"')
                // Replace all new lines with spaces.
                .replace(/\r\n|\n\r|\n|\r/g, " ")
            );
          }
        )
        // Split each line into rows
        .split(/\r\n|\n\r|\n|\r/g);
      console.log(rows);
    },
    async carbonemissions_add(s) {
      this.carbonemissions.items.push({
        id: "",
        type: "",
        eventcode: "",
        slac: "",
        startdate: "",
        traveller: "",
        startcity: "",
        duration: "",
        quantity: "",
        distance: "",
        category: "",
        ticketno: "",
        flightno: "",
        confirmationno: "",
        vehicle: "",
        supplier: "",
        endcity: "",
      });
    },
    // async carbonemissions_delete(e) {
    //   // PASS THE ID LIST TO DELETE MUTATION

    //   let variables = {
    //     rows: this.cleanit(e),
    //   };

    //   try {
    //     const response = await this.$apollo.mutate({
    //       mutation: gql`
    //         mutation carbonemissions_delete($rows: [Carbonemission_input]) {
    //           carbonemissions_delete(rows: $rows) {
    //             id
    //           }
    //         }
    //       `,
    //       variables,
    //     });
    //   } catch (error) {
    //   }
    //   await this.load();
    // },
  },
};
</script>

<style>
.card {
  text-align: left !important;
}
</style>